import { makeStyles } from 'tss-react/mui';

import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { LEGACY_HEADER_HEIGHT } from '@/styles/theme/constants';
import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark?: boolean;
}

const useStyles = makeStyles<Props>({ name: 'RichText' })(
  (
    { breakpoints, type, spacing, brandColors, fontWeights, typography },
    props
  ) => ({
    container: {
      color: darkOrLightStyle(props)(
        brandColors.tintsOffWhite40,
        brandColors.tintsNeutral20
      ),
      scrollMargin: LEGACY_HEADER_HEIGHT,
      '& h1, h2, h3, h4, h5': {
        color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
      },
      '& h1': {
        marginBottom: spacing(1),
      },
      '& h2, h3': {
        marginBottom: spacing(0),
      },
      '& h4, h5': {
        marginBottom: spacing(-1),
      },
      '& p': {
        '& a': {
          ...type['18_medium-hyperlink'],
          [breakpoints.down('lg')]: {
            ...type['16_medium-hyperlink'],
          },
          [breakpoints.down('sm')]: {
            ...type['14_medium-hyperlink'],
          },
        },
      },
      '& p:not(:last-child)': {
        marginBottom: '1.875rem',
      },
      '& li': {
        ...type['18_regular'],
        [breakpoints.down(ScreenSize.MEDIUM)]: {
          ...type['16_medium'],
        },
        [breakpoints.down(ScreenSize.EXTRA_SMALL)]: {
          ...type['14_medium'],
        },
        '& p': {
          marginBottom: 0,
        },
        marginBottom: 0,
      },
      '& li::before': {
        ...type['18_regular'],
        [breakpoints.down(ScreenSize.MEDIUM)]: {
          ...type['16_medium'],
        },
        [breakpoints.down(ScreenSize.EXTRA_SMALL)]: {
          ...type['14_medium'],
        },
      },
      '& table, th, td': {
        border: 'solid 1px black',
      },
      '& th, td': {
        padding: '10px',
        '& p': {
          margin: '0!important',
        },
      },
      '& th': {
        textAlign: 'left',
      },
    },
    links: {
      '& p': {
        '& a': {
          color: darkOrLightStyle(props)(
            brandColors.white,
            brandColors.primaryMain
          ),
          '&:hover': {
            color: darkOrLightStyle(props)(
              brandColors.chargeBlue,
              brandColors.mediumBlue
            ),
          },
          '&:visited': {
            color: brandColors.tintsChargeBlue30,
            background: 'initial',
          },
        },
      },
    },
    tableCell: {
      minWidth: typography.pxToRem(100),
      '&&': {
        borderColor: darkOrLightStyle(props)(
          brandColors.white,
          brandColors.black
        ),
        '& > p': {
          color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
        },
      },
    },
    tableHeaderCell: {
      '&& > p': {
        fontWeight: fontWeights.semibold,
      },
    },
  })
);

export default useStyles;
